import * as React from "react";
import { inl, inr, IOWidget, mk_widget, Sum } from "../widget";

interface EitherProps<i,o1,o2> {
  input:i
  widget1:IOWidget<i,o1>
  widget2:IOWidget<i,o2>
  on_done_either:(output:Sum<o1,o2>) => void
}
interface EitherState<_i,_o1,_o2> {}

/**
 * @deprecated Don't use directly, use the [[either]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
class Either<i,o1,o2> extends React.Component<EitherProps<i,o1,o2>, EitherState<i,o1,o2>> {
  constructor(props:EitherProps<i,o1,o2>, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return <>
      {this.props.widget1(this.props.input).run(output1 =>
        this.props.on_done_either(inl(output1)))}
      {this.props.widget2(this.props.input).run(output2 =>
        this.props.on_done_either(inr(output2)))}
      </>
  }
}

export const either = function<i,o1,o2>(widget1:IOWidget<i,o1>, widget2:IOWidget<i,o2>) :
  IOWidget<i,Sum<o1,o2>> {
  return (input:i) => mk_widget({
    run:(on_done_either:(outputs:Sum<o1,o2>) => void) =>
      React.createElement<EitherProps<i,o1,o2>>(Either, { on_done_either, widget1, widget2, input })
  })
}
